/* oxlint-disable */
'use client';

import React, { useState, useEffect } from 'react';

import Image from 'next/image';
import { usePathname } from 'next/navigation';

import { FcGoogle } from 'react-icons/fc';

import { z } from 'zod';

// import { AuthType, Vendors } from '@/enums/core';
// import { FormEmailAndPassword, FormPhoneCodeAndPassword, FormPhoneNumber } from '@/features/auth/components';
import { FormEmailAndPassword } from '@/features/auth/components';

import ForgotPassword from '@/features/auth/components/ForgotPassword';
import { messages } from '@/features/auth/localization/texts';

// import { handleSendPhoneCode } from '@/features/auth/services';
import { core, errors } from '@/localization';

import { userUIStore } from '@/stores/userUIStore';

import { exception } from '@/utils/helpers';

import { useAuth } from '@/core/auth/client/AuthProvider';

import {
  Dialog, DialogContent, DialogTitle, DialogTrigger,
} from '@/components/ui/dialog';

import { useToast } from '@/components/ui/use-toast';

import { Button } from '../ui/button';

// Solitics env
// const SOLITICS_BRAND = process.env.NEXT_PUBLIC_SOLITICS_BRAND!;
// const SOLITICS_POPUP_TOKEN = process.env.NEXT_PUBLIC_SOLITICS_POPUP_TOKEN!;
// const SOLITICS_BRANCH = process.env.NEXT_PUBLIC_SOLITICS_BRANCH!;
interface Props {
  isDefaultOpen?: boolean;
}

const LoginModal = ({ isDefaultOpen = false }: Props) => {
  const [isMobileForm, setIsMobileForm] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { isLoginModalOpen, toggleLoginModal, toggleRegisterModal } = userUIStore();
  // const [phoneNumber, setPhoneNumber] = useState<string>('');
  // const [opt, setOpt] = useState<any>(null);
  // const url = usePathname();
  // const params = useSearchParams();
  const pathname = usePathname();
  const excludePaths = ['/deposit'];

  // Better Auth integration
  const { signIn, signInWithGoogle } = useAuth();

  // const urlRedirect = `${url}?gamecode=${params.get('gamecode')}&provider=${params.get('provider')}`;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Consider mobile if width <= 768px
    };

    handleResize(); // Initialize on first render
    window.addEventListener('resize', handleResize);

    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleForgotPassword = () => {
    setShowForgotPassword(!showForgotPassword);
  };

  const handleBackFromForgotPassword = () => {
    setShowForgotPassword(false);
  };
  const { toast } = useToast();

  // const getCallbackUrl = () => {
  //   if (url.includes('/casino/play')) {
  //     return urlRedirect;
  //   }
  //   if (pathname === '/deposit') {
  //     return '/deposit';
  //   }
  //   return '/';
  // };

  // const reportSolticsLogin = (memberId: string, email: string, method: string) => {
  //   // Fire and forget - don't let Solitics errors break the auth flow
  //   try {
  //     if (typeof window !== 'undefined' && (window as any).$solitics) {
  //       const loginObj = {
  //         memberId,
  //         email,
  //         brand: SOLITICS_BRAND,
  //         popupToken: SOLITICS_POPUP_TOKEN,
  //         branch: SOLITICS_BRANCH,
  //         customFields: {
  //           loginMethod: method,
  //           currentPage: window.location.pathname,
  //         },
  //       };
  //       (window as any).$solitics.loginSuccess(loginObj);
  //     }
  //   } catch (error) {
  //     // Silently fail - don't break the auth flow for tracking issues
  //     console.warn('Solitics tracking failed:', error);
  //   }
  // };

  // SIGNIN - Google OAuth with Better Auth
  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);

      // Use Better Auth Google OAuth
      await signInWithGoogle();

      // Close the modal on successful login
      toggleLoginModal();
    } catch (error: any) {
      setLoading(false);

      // Handle Better Auth specific errors for Google OAuth
      const errorMessage = error.message?.toLowerCase() || '';
      if (errorMessage.includes('cancelled') || errorMessage.includes('popup')) {
        toast({ title: 'Inicio de sesión cancelado', variant: 'default' });
      } else if (errorMessage.includes('network') || errorMessage.includes('connection')) {
        toast({ title: 'Error de conexión. Intenta de nuevo.', variant: 'destructive' });
      } else {
        toast({ title: 'Error al iniciar sesión con Google. Intenta de nuevo.', variant: 'destructive' });
      }
    }
  };

  const handleEmailAndPassSignIn = async (values: z.infer<any>):Promise<void> => {
    try {
      setLoading(true);
      if (values.email && values.password) {
        // Use Better Auth sign in
        await signIn(values.email, values.password, true); // Remember me = true

        // Close the modal on successful login
        toggleLoginModal();
      } else {
        setLoading(false);
        toast({ title: 'Email y contraseña son requeridos', variant: 'destructive' });
      }
    } catch (error: any) {
      setLoading(false);

      // Handle Better Auth specific errors
      const errorMessage = error.message?.toLowerCase() || '';
      if (errorMessage.includes('invalid') || errorMessage.includes('credentials')) {
        toast({ title: messages.errorInvalidCredentials, variant: 'destructive' });
      } else if (errorMessage.includes('not found')) {
        toast({ title: 'No se encontró una cuenta con este correo', variant: 'destructive' });
      } else {
        toast({ title: errors.tryAgain, variant: 'destructive' });
      }
    }
  };

  // Phone authentication temporarily disabled during Better Auth migration
  // const handleSendCodeToPhone = async (values: z.infer<any>):Promise<void> => {
  //   toast({ title: 'Autenticación por teléfono temporalmente deshabilitada', variant: 'destructive' });
  //   // TODO: Implement phone authentication with Better Auth
  //   try {
  //     setLoading(true);
  //     const currentPhoneNumber = `+${values.phone}`;
  //     setPhoneNumber(currentPhoneNumber);
  //     const result = await handleSendPhoneCode(currentPhoneNumber);
  //     // ... rest of phone logic
  //   } catch (error) {
  //     setLoading(false);
  //     await exception(error, { route: '/components/modals/LoginModal.tsx: handleSendCodeToPhone', method: 'POST', req: { values } });
  //     toast({ title: errors.tryAgain, variant: 'destructive' });
  //   }
  // };

  // const handleCheckPhoneCodeAndRegisterWithPhone = async (values: z.infer<any>):Promise<void> => {
  //   toast({ title: 'Autenticación por teléfono temporalmente deshabilitada', variant: 'destructive' });
  //   // TODO: Implement phone verification with Better Auth
  //   try {
  //     setLoading(true);
  //     // ... phone verification logic
  //   } catch (error) {
  //     setLoading(false);
  //     await exception(error, { route: '/components/modals/LoginModal.tsx: handleCheckPhoneCodeAndRegisterWithPhone', method: 'POST', req: { values } });
  //     toast({ title: errors.tryAgain, variant: 'destructive' });
  //   }
  // };

  // SIGNIN\
  return (
    <Dialog
      modal={false}
      defaultOpen={isDefaultOpen}
      open={isLoginModalOpen}
      onOpenChange={toggleLoginModal}
    >
      {!excludePaths.includes(pathname) && !isDefaultOpen && (
        <DialogTrigger asChild>
          <Button className="bg-sivarbet-primary text-sivarbet-background font-semibold" size="sm" variant="secondary">
            {messages.login}
          </Button>
        </DialogTrigger>
      )}
      <DialogContent
        onOpenAutoFocus={(e) => { return e.preventDefault(); }}
        onInteractOutside={(e) => { e.preventDefault(); }}
        className="bg-sivarbet-secondary-bg border-none p-0 flex flex-col lg:flex-row lg:flex-nowrap lg:max-w-[816px] lg:max-h-[630px] h-full rounded-lg"
        colorClose={`${isMobile ? 'text-sivarbet-secondary-bg max-md:h-7! max-md:w-7!' : 'text-sivarbet-primary'}`}
      >
        <div className={`relative ${isMobile ? 'w-full h-3/4' : 'w-1/2 h-auto'}`}>
          <Image
            src={isMobile ? '/img/marketing/promotions/loginMovil.webp' : '/img/marketing/promotions/loginWeb.webp'}
            alt="Login Promo"
            fill
            objectFit="cover"
            objectPosition="center"
            sizes="(max-width: 768px) 100vw, 50vw"
            priority
          />
        </div>
        <section className="lg:w-[50%] flex flex-col justify-center h-full pb-5">

          <DialogTitle className="flex items-center justify-start relative text-inherit leading-[20px] font-medium font-inherit mx-[17px] mb-8">
            {`${messages.enterTo} ${core.appName}`}
          </DialogTitle>
          <div className="h-[11px] relative tracking-[-0.01em] leading-[20px] inline-block mx-[17px] max-lg:hidden mb-6">
            <span className="mr-2">{messages.dontHaveAnAccount}</span>
            <span
              onClick={() => {
                toggleLoginModal();
                toggleRegisterModal();
              }}
              className="[text-decoration:underline] text-sivarbet-primary cursor-pointer"
            >
              {messages.enterHere}
            </span>
          </div>
          {
            showForgotPassword ? (
              <ForgotPassword onBack={handleBackFromForgotPassword} />
            ) : (
              <>
                {/* {isMobileForm && !opt && <FormPhoneNumber action={handleSendCodeToPhone} disabled={loading} /> }
                {isMobileForm && opt && <FormPhoneCodeAndPassword action={handleCheckPhoneCodeAndRegisterWithPhone} disabled={loading} isRegister={false} /> } */}
                {!isMobileForm && <FormEmailAndPassword action={handleEmailAndPassSignIn} disabled={loading} isRegister={false} />}
                <div className="h-[11px] relative tracking-[-0.01em] leading-[20px] inline-block mx-[17px] lg:hidden mb-5">
                  <span>{messages.dontHaveAnAccount}</span>
                  <span
                    onClick={() => {
                      toggleLoginModal();
                      toggleRegisterModal();
                    }}
                    className="[text-decoration:underline] text-sivarbet-primary cursor-pointer"
                  >
                    {messages.enterHere}
                  </span>
                </div>
                <div className="self-stretch flex flex-col items-start justify-start gap-[30px] text-mini text-third_text mx-[17px]">
                  <div className="self-stretch flex flex-row flex-wrap items-start justify-start gap-[10px]">
                    <div className="center-box">
                      <div className="self-stretch h-px relative box-border border-t border-solid border-sivarbet-border" />
                    </div>
                    <div className="relative leading-[11px] inline-block min-w-[104px]">
                      {messages.orContinueWith}
                    </div>
                    <div className="center-box">
                      <div className="self-stretch h-px relative box-border border-t border-solid border-sivarbet-border" />
                    </div>
                  </div>
                  <div className="self-stretch flex flex-col items-start justify-start gap-[10px]">
                    <Button disabled={loading} onClick={() => { setIsMobileForm(!isMobileForm); }} type="button" className="cursor-pointer [border:none] py-[10.5px] px-5 bg-sivarbet-background self-stretch rounded-lg overflow-hidden flex flex-row items-center justify-center gap-[8px]">
                      <span className={`icon icon-${!isMobileForm ? 'phone' : 'mail'} text-sivarbet-primary mt-1`} />
                      <div className="w-[145px] flex items-center justify-center pt-[4.5px] px-0 pb-0 box-border">
                        <div className="self-stretch h-2.5 relative text-sm leading-[20px] font-medium font-text-sm-medium text-sivarbet-primary text-center flex items-center justify-center">
                          {`${messages.continueWith} ${isMobileForm ? messages.yourEmail.toLocaleLowerCase() : messages.yourPhone.toLocaleLowerCase()}`}
                        </div>
                      </div>
                    </Button>
                    <Button disabled={loading} onClick={handleGoogleSignIn} type="button" className="cursor-pointer [border:none] py-[10.5px] px-5 bg-sivarbet-background self-stretch rounded-lg overflow-hidden flex flex-row items-start justify-center gap-[8px]">
                      <FcGoogle className="text-lg" />
                      <div className="w-[145px] flex items-center justify-center pt-[4.5px] px-0 pb-0 box-border">
                        <div className="self-stretch h-2.5 relative text-sm leading-[20px] font-medium font-text-sm-medium text-sivarbet-primary text-center flex items-center justify-center">
                          {`${messages.continueWith} ${messages.google}`}
                        </div>
                      </div>
                    </Button>

                  </div>
                  <div className="text-center mt-4 items-center">
                    <span
                      onClick={toggleForgotPassword}
                      className="text-sivarbet-primary cursor-pointer hover:underline"
                    >
                      {messages.forgotPassword}
                    </span>
                  </div>
                </div>
              </>
            )
          }
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
